"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "react-i18next";
import type { PaymentsDoneState } from "@/types/payments";
import SegmentedControl from "./SegmentedControl";
type Props = {
  value: PaymentsDoneState;
  onChange: (value: PaymentsDoneState) => void;
};
export default function PaymentsDoneFilter(t0) {
  const $ = _c(32);
  const {
    value,
    onChange
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("paymentsReceived.doneFilter.all");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      key: "all",
      label: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("paymentsReceived.doneFilter.yes");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      key: "yes",
      label: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("paymentsReceived.doneFilter.no");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = {
      key: "no",
      label: t5
    };
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t4 || $[14] !== t6) {
    t7 = [t2, t4, t6];
    $[12] = t2;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const options = t7;
  let t8;
  if ($[16] !== t) {
    t8 = t("paymentsReceived.doneFilter.label");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <span className="text-xs font-medium text-foreground/70">{t8}</span>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("paymentsReceived.doneFilter.label");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== onChange) {
    t11 = key => onChange(key as PaymentsDoneState);
    $[22] = onChange;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== options || $[25] !== t10 || $[26] !== t11 || $[27] !== value) {
    t12 = <SegmentedControl ariaLabel={t10} options={options} value={value} onChange={t11} />;
    $[24] = options;
    $[25] = t10;
    $[26] = t11;
    $[27] = value;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12 || $[30] !== t9) {
    t13 = <div className="flex items-center gap-2">{t9}{t12}</div>;
    $[29] = t12;
    $[30] = t9;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
}